import { NgModule } from "@angular/core";
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationGuard } from "src/app/core/guards/authorization.guard";
import { AuthenticationGuard } from "src/app/core/guards/authentication.guard";
import { ScUserMessageListComponent } from "./sc-user-message-list/sc-user-message-list.component";

const routes: Routes = [
  {
    path: 'list', component: ScUserMessageListComponent,
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: {
      roles: ['SF_ADMIN', 'ROLE_SF_SELLER', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SERVICE', 'ROLE_CLIENT'],
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScUserRoutingModule { }
